import { render } from "./VaultTransactions.vue?vue&type=template&id=7739f3ae&ts=true"
import script from "./VaultTransactions.vue?vue&type=script&lang=ts"
export * from "./VaultTransactions.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__